import { Trip } from "../../DataStructures/Trip/Trip";
import { MapControls } from "../MapControls/MapConrols";
import { reject } from "q";
import { DirectionOptions } from "../../DataStructures/DirectionOptions/DirectionOptions";
import { SettingValues } from "../../admin-dashboard/settings/SettingValues";
import { Area } from "../../DataStructures/Area/Area";
import { Injectable } from "@angular/core";
import { MainService } from "../../services/optimizer-service/optimizer.service";
import { CacheService } from "../../services/cache-service/cache.service";

declare var google: any;

@Injectable()
export class DirectionsService {


    directionsService;
    areasPerRequest: Array<Array<Area>> = [];
    maxRequestSize = SettingValues.maxRequestSize;

    constructor(private cacheSerivce:CacheService) {
        this.instantiateDirectionsService();
    }

    instantiateDirectionsService() {
        this.directionsService = new google.maps.DirectionsService();
    }


    divisionComplete(trip: Trip) {

        var sum = 0;
        this.areasPerRequest.forEach(r => {
            sum += r.length;
        });

        if (sum >= trip.areas.length) {
            return true;
        } else {
            return false;
        }
    }


    calculateSplitDirection(trip: Trip,options: DirectionOptions): Promise<{trip:Trip,status:any}> {

        return new Promise(async (resolve, reject) => {

            trip.legs = [];
            trip.currentLegIndex = 0;
            
            var startingPoint = 0;
            var endingPoint = this.maxRequestSize;

            while (!this.divisionComplete(trip)) {

                var areas = trip.areas.slice(startingPoint, endingPoint);
                this.areasPerRequest.push(areas);
                startingPoint += areas.length;
                endingPoint += this.maxRequestSize;
            }

            var destination = null;
            var origin = null;
            var waypoints: Array<any> = null;
            var currentAreaRequest: Array<Area> = null;
            var lastPointInCurrentAreaRequest: LatLng = null;

            if (this.areasPerRequest.length < 2) {
                origin = new google.maps.LatLng(trip.source.destinations[0].lat, trip.source.destinations[0].lng);
                destination = new google.maps.LatLng(trip.destination.destinations[0].lat, trip.destination.destinations[0].lng);
                var waypoints = this.getTripWayPoints(trip);

                await this.makeRequest(this.createRequest(origin, destination, waypoints,options,true)).then(result =>{

                    trip.legs.push(result);

                }).catch(e =>{
                    
                    reject({trip:null,status:e});
                })

            } else {

                for (var i = 0; i < this.areasPerRequest.length; i++) {

                    currentAreaRequest = this.areasPerRequest[i];
                    lastPointInCurrentAreaRequest = currentAreaRequest[currentAreaRequest.length - 1].getLatLng();

                    //First Iteration 
                    if (i == 0) {

                        origin = new google.maps.LatLng(trip.source.destinations[0].lat, trip.source.destinations[0].lng);
                        waypoints = this.getWayPoints(currentAreaRequest.slice(0, currentAreaRequest.length - 1));
                        destination = new google.maps.LatLng(lastPointInCurrentAreaRequest.lat, lastPointInCurrentAreaRequest.lng);

                        await this.makeRequest(this.createRequest(origin, destination, waypoints,options,true)).then(result =>{

                            trip.legs.push(result);

                        }).catch(e =>{
                            
                            reject({trip:null,status:e});
                        })

                        //Last Iteration
                    } else if (i == this.areasPerRequest.length - 1) {

                        origin = destination;
                        waypoints = this.getWayPoints(currentAreaRequest.slice(0, currentAreaRequest.length));
                        destination = new google.maps.LatLng(trip.source.destinations[0].lat, trip.source.destinations[0].lng);

                        await this.makeRequest(this.createRequest(origin, destination, waypoints,options,true)).then(result =>{

                            trip.legs.push(result);

                        }).catch(e =>{
                            
                            reject({trip:null,status:e});
                        })

                    } else {

                        origin = destination;
                        waypoints = this.getWayPoints(currentAreaRequest.slice(0, currentAreaRequest.length - 1));
                        destination = new google.maps.LatLng(lastPointInCurrentAreaRequest.lat, lastPointInCurrentAreaRequest.lng);

                        await this.makeRequest(this.createRequest(origin, destination, waypoints, options,true)).then(result =>{

                            trip.legs.push(result);

                        }).catch(e =>{
                            
                            reject({trip:null,status:e});
                        })
                    }
                }
            }

            resolve({trip:trip,status:"OK"});
        });

    }

    private getWayPoints(areas: Array<Area>) {

        var waypoints = [];
        areas.forEach((area) => {

            waypoints.push(
                {
                    location: new google.maps.LatLng(area.destinations[0].lat, area.destinations[0].lng),
                    stopover: true
                }
            );
        })
        return waypoints;
    }

    private createRequest(origin, destination, waypoints,options: DirectionOptions,waypointsCreated:boolean = false) {

        return {
            origin: origin,
            destination: destination,
            avoidTolls: options.avoidTolls,
            waypoints: waypointsCreated ? waypoints : this.getTripWayPoints(waypoints),
            optimizeWaypoints: false,
            travelMode: 'DRIVING'
        };
    }



    private makeRequest(request): Promise<any> {

        return new Promise( async (resolve, reject) => {

            var response = await this.cacheSerivce.getDirectionsRoute(request);
            if(response.data){
                resolve(response.data);
            }else{
                this.directionsService.route(request, async (result, status) => {
                    if (status == "OK") {
                        this.cacheSerivce.saveDirectionsRoute(request,result);
                        resolve(result)
                    } else {
                        reject(status);
                    }
                });
            }
        });
    }

    //THIS ESSENCE IS TO CALCULATE THE ORDER OF THE STOPS
    calculateDirections(trip: Trip, options: DirectionOptions): Promise<any> {

        return new Promise(async (resolve, reject) => {

            if(options == null){
                options = {
                    splitDirections:false,
                    avoidTolls: false
                };
            }

            if(options.splitDirections){

                await this.calculateSplitDirection(trip,options).then(result =>{
                    resolve(result);
                }).catch(e =>{
                    reject(e);
                });
            }else{

                var request = null;
                var destination = new google.maps.LatLng(trip.destination.destinations[0].lat, trip.destination.destinations[0].lng);
    
                if (options == null) {
                    request = {
                        origin: new google.maps.LatLng(trip.source.destinations[0].lat, trip.source.destinations[0].lng),
                        destination: destination,
                        waypoints: this.getTripWayPoints(trip),
                        optimizeWaypoints: false,
                        travelMode: 'DRIVING'
                    };
                } else {
    
                    request = {
                        origin: new google.maps.LatLng(trip.source.destinations[0].lat, trip.source.destinations[0].lng),
                        destination: destination,
                        waypoints: this.getTripWayPoints(trip),
                        avoidTolls: options.avoidTolls,
                        optimizeWaypoints: false,
                        travelMode: 'DRIVING'
                    };
                }
    
    
                var THIS = this;
    
    
                var error = { trip: null, status: "Unexpected Error, directionsService.route() failed (0x000)" };
                var result = {};
                await this.directionsService.route(request, async (result, status) => {
                    if (status == "OK") {
                        trip.directions = result;
                        console.log(trip.directions);
                        trip.time = THIS.calculateRoundTripDuration(result);
                        error = null;
                        result = { trip: trip, status: status }
                    } else {
                        error = { trip: null, status: status }
                    }
                    if (error) {
                        reject(error);
                    } else {
                        resolve(result);
                    }
    
                });
            }

        })

    }

    private getTripWayPoints(trip: Trip) {

        var waypoints = [];
        trip.areas.forEach((area) => {
            
            waypoints.push(
                {
                    location: new google.maps.LatLng(area.destinations[0].lat, area.destinations[0].lng),
                    stopover: true
                }
            );
        })
        return waypoints;
    }

    public calculateRoundTripDuration(response) {

        var legs: Array<any> = response.routes[0].legs;
        var totalTimeSeconds = 0;
        legs.forEach(leg => {

            totalTimeSeconds += leg.duration.value;
        });

        return totalTimeSeconds;
    }

    /*
    addDirectionsMarkers(trip: Trip, mapControls: MapControls) {

        var markers = [];
        var counter = 1;
        var legs = trip.directions.routes[0].legs;
        var areas = [];
        areas.push(trip.source);
        trip.areas.forEach(a => {
            areas.push(a);
        })
        legs.forEach(leg => {
            var marker = mapControls.addMarker(leg.start_location, counter.toString());
            marker.address = leg.address;
            marker.trip = trip;
            marker.addListener('click', () => { mapControls.openInfoWindow(marker.address, marker) });
            markers.push(marker);
            counter++;
        });
        return markers;
    }*/
}


// WEBPACK FOOTER //
// ./src/app/utilities/DirectionsService/DirectionsService.ts